exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tutorial h6 {\n  text-decoration: underline;\n  margin-top: 3rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./demo/tutorial.scss
// module id = 26
// module chunks = 0